<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-hover v-slot:default="{ hover }">

        <v-menu
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn icon small @click="$emit('click')" class="edit-btn" v-on="on">
              <v-icon small :color="hover ? 'blue lighten-1' : 'grey'">
                mdi-dots-vertical
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, i) in options"
              :key="i"
              @click="$emit(item.event)"
            >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-hover>
    </template>
    <span>Možnosti</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    client: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      clientMenu: [
        {
          title: 'Prevzemi identiteto',
          icon: 'mdi-account-convert',
          event: 'identity'
        },
        {
          title: 'Uredi',
          icon: 'mdi-pencil',
          event: 'edit'
        },
        {
          title: 'Podrobnosti',
          icon: 'mdi-file-eye-outline',
          event: 'details'
        },
        {
          title: 'Poslovne enote',
          icon: 'mdi-sitemap',
          event: 'businessUnits'
        },
        {
          title: 'Digitalno potrdilo',
          icon: 'mdi-certificate',
          event: 'certificates'
        }
      ],
      distributorMenu: [
        {
          title: 'Uredi',
          icon: 'mdi-pencil',
          event: 'edit'
        },
        {
          title: 'Podrobnosti',
          icon: 'mdi-file-eye-outline',
          event: 'details'
        }
        // {
        //   title: 'Prevzemi identiteto',
        //   icon: 'mdi-account-convert',
        //   event: 'identity'
        // }
      ]
    }
  },
  computed: {
    options () {
      return this.client.company_type === 1 ? this.clientMenu : this.distributorMenu
    }
  }
}
</script>
